import { render, staticRenderFns, recyclableRender, components } from "./u-overlay.vue?vue&type=template&id=b2a05bc2&scoped=true&"
var renderjs
import script from "./u-overlay.vue?vue&type=script&lang=js&"
export * from "./u-overlay.vue?vue&type=script&lang=js&"
import style0 from "./u-overlay.vue?vue&type=style&index=0&id=b2a05bc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\前端软件\\HBuilderX.3.2.12.20211029\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a05bc2",
  null,
  false,
  components,
  renderjs
)

export default component.exports